import { Inject, Injectable } from "@angular/core";

import { ENV } from "../environment/environment.token";
import { LogentriesEnvironment } from "./logentries-environment.model";
import { Logger } from "./logger.interface";

/** True når vi kører på maskinlokalt (localhost, 127.0.0.1, ::1) eller dev-miljø der ikke skal ramme Logentries. */
export function shouldSkipLogentriesForHostname(hostname: string): boolean {
    if (hostname === "dev-eforsyning.softvaerket.dk") {
        return true;
    }
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return true;
    }
    // IPv6 loopback (browser hostname kan være "[::1]" eller "::1" afhængigt af URL)
    return hostname === "[::1]" || hostname === "::1";
}

/** True når fejl/logs må sendes til Logentries (ikke lokal/dev-host, eller tvunget via eforsyningForceLogentries). */
export function isLogentriesRemoteLoggingEnabled(): boolean {
    const hostname = window.location.hostname;
    const forceLogentries =
        (globalThis as any).eforsyningForceLogentries === true || localStorage.getItem("eforsyningForceLogentries") === "true";
    return forceLogentries || !shouldSkipLogentriesForHostname(hostname);
}

@Injectable() // Injectes med @Inject(LOGGER)
export class LogentriesLoggerService implements Logger {
    private baseUrl = "https://webhook.logentries.com/noformat/logs/";

    constructor(@Inject(ENV) public environment: LogentriesEnvironment) {}

    public log(logFields: any): void {
        if (!isLogentriesRemoteLoggingEnabled()) {
            return;
        }

        logFields = { ...logFields, Application: this.environment.logentries.application };
        const value = this.genererLogValue(logFields);
        this.post(value);
    }

    private genererLogValue(logFields: any): string {
        const result = Object.keys(logFields)
            .filter((key) => typeof logFields[key] !== "undefined")
            .map((key) => `${key}: ${this.formatValue(logFields[key])}`);
        // Indtil videre fjerner vi linjeskift, da Log Entries afslutter ved første linjeskift.
        return result.join(", ").replace(/\n/g, " ");
    }

    private formatValue(value: any): string {
        const validChars = /^[0-9a-zA-Z_\-. ]*$/g;
        const isValid = validChars.test(value);
        return isValid ? (value || "").toString() : `"${value}"`;
    }

    private post(value: any): void {
        const request = new XMLHttpRequest();
        request.open("POST", this.baseUrl + this.environment.logentries.token);
        request.send(value);
    }
}
